module.exports = __webpack_public_path__ + "img/main-q-mwallet.569f8bd2.png";